import { Expose, Type } from "class-transformer";
import { ValidateNested } from "class-validator";
import { ExchangeRate } from "../../entity";

export class GetAllExchangeRateDTO {
  @Expose()
  @ValidateNested()
  @Type(() => ExchangeRate)
  exchangeRates!: ExchangeRate[];
}
